<template>
    <div>
        <ul class="nav nav-tabs mb-2 d-print-none" :class="toEdge ? 'px-3 mx-n3' : null">
            <li class="nav-item" v-for="(tab, idx) in tabs" :key="idx">
                <a
                    role="tab"
                    :id="`${tab.uid}-tab-button`"
                    class="nav-link"
                    :class="selectedTab === tab ? 'active' : null"
                    :aria-current="selectedTab === tab ? 'page' : null"
                    href="#"
                    @click="e => setSelectedTab(tab, e)"
                    >
                    {{tab.title}}
                </a>
            </li>
        </ul>
        <div class="tab-content">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'AlzataTabs',
    props: {
        toEdge: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["selected"],
    methods: {
        registerTab(tab) {
            this.tabs.push(tab);
            if (this.selectedTab === null) {
                this.selectedTab = tab;
            }
        },
        unregisterTab() {
            this.tabs.pop();
        },
        reset() {
            this.selectedTab = this.tabs[0];
        },
        setSelectedTab(tab, evt) {
            evt.preventDefault();
            this.selectedTab = tab;

            this.$emit("selected", tab);
        }
    },
    data() {
        return {
            selectedTab: null,
            tabs: [],
        };
    },
}
</script>